import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import Page from "@/pages/Page";
import AdminLogin from "@/pages/AdminLogin";
import { AdminGate, AdminDashboard, AdminEdit } from "@/pages/Admin";
import { AuthProvider } from "@/auth";

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Layout>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin" element={<AdminGate><AdminDashboard /></AdminGate>} />
            <Route path="/admin/edit/:slug" element={<AdminGate><AdminEdit /></AdminGate>} />
            <Route path="/:slug" element={<Page />} />
          </Routes>
        </Layout>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
